"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryAmountWithEquivalent = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("./fonts");
var _ticker = require("../ticker");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TickerAmount = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryShade2;
});
var FiatTickerAmount = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  font-weight: normal;\n"])));
var Title = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
});
var PrimaryAmountWithEquivalent = function PrimaryAmountWithEquivalent(props) {
  var _props$component;
  var fiatAmountChildren = props.convertedAmount && props.convertedTicker && [/*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: props.convertedTicker
  }), ' ', /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    rounding: props.rounding,
    value: props.convertedAmount,
    ticker: props.convertedTicker
  })];
  if (!_definitions.FIAT_TICKERS.includes(props.convertedTicker) && fiatAmountChildren) fiatAmountChildren = fiatAmountChildren.reverse();
  return /*#__PURE__*/_react.default.createElement(Title, {
    as: (_props$component = props.component) !== null && _props$component !== void 0 ? _props$component : _fonts.H3,
    className: props.className
  }, /*#__PURE__*/_react.default.createElement(TickerAmount, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    rounding: props.rounding,
    value: props.amount,
    ticker: props.ticker
  }), ' ', props.ticker), ' ', fiatAmountChildren && /*#__PURE__*/_react.default.createElement(FiatTickerAmount, null, "= ", fiatAmountChildren));
};
exports.PrimaryAmountWithEquivalent = PrimaryAmountWithEquivalent;